import { Button } from "@/components/ui/button";

interface GoogleOAuthButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  isDarkMode: boolean;
}

const GoogleIcon = () => (
  <svg className="w-5 h-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
    />
  </svg>
);

/**
 * Google OAuth sign-in button component
 */
export function GoogleOAuthButton({
  onClick,
  disabled = false,
  loading = false,
  isDarkMode,
}: GoogleOAuthButtonProps) {
  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      variant="outline"
      size="lg"
      className={`mb-4 w-full transition-all duration-200 rounded-[6px] ${
        isDarkMode
          ? "bg-[#374151] text-[#f9fafb] border-[#4b5563] hover:bg-[#4b5563] hover:border-[#6b7280] focus-visible:ring-blue-500"
          : "bg-[#f9fafb] text-[#374151] border-[#d1d5db] hover:bg-[#f3f4f6] hover:border-[#9ca3af] focus-visible:ring-blue-500"
      }`}
      aria-label="Continue with Google"
    >
      {!loading && <GoogleIcon />}
      {loading ? "Signing in..." : "Continue with Google"}
    </Button>
  );
}
